import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { color } from "../Utils/Constant";
import { HiUserAdd } from "react-icons/hi";
import ProfilePic from "../../src/Assets/profile_pic.jpg";

const StyledIcon = styled.div`
  color: ${(props) => (props.active ? color.primary : color.white)};
  font-size: 25px;
  width: 38px;
  height: 38px;
  background-color: ${(props) => (props.active ? color.white : color.blue)};
  border-radius: 50%;
  padding: 5px;
  object-fit: contain;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: color 0.3s ease;
  &:hover {
    background-color: ${color.white};
    color: ${color.primary};
  }
`;

const VCardGenerator = () => {
  const [userData, setUserData] = useState(null);
  const [base64Image, setBase64Image] = useState("");
  const [loading, setLoading] = useState(true);

  const apiUrl = "https://nfcadmin.mediastreambh.com/public/api/data/Om D Ramchandani";
  // const imageBaseUrl = "https://nfcadmin.dhanamtechnologiesbh.com/public/";

  // Fetch user data from API
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(apiUrl);
        const result = await response.json();

        if (result.success && result.data.length > 0) {
          const user = result.data[0];
          setUserData(user);

          // if (user.profile_image) {
          //   const base64 = await fetchImageAsBase64(user.profile_image);
          //   setBase64Image(base64);
          // }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);


  // converting profile image to base64 format
    const convertImageToBase64 = async () => {
      const img = new Image();
      img.src = ProfilePic;
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // Convert image to Base64
        const base64String = canvas.toDataURL("image/jpeg").split(",")[1];

        // Break Base64 string into 75-character lines (required for vCard)
        let formattedBase64 = base64String.match(/.{1,75}/g).join("\r\n ");

        setBase64Image(formattedBase64);
      };
    };

    convertImageToBase64();

  // Function to fetch and convert image to Base64
  // const fetchImageAsBase64 = async (imagePath) => {
  //   try {
  //     const imageUrl = `${imageBaseUrl}${imagePath}`;
  //     // const imageUrl = `https://nfcadmin.dhanamtechnologiesbh.com/public/${imagePath}`;
  
  //     // Fetch image as blob
  //     const response = await fetch(imageUrl, { mode: "cors" });
  //     if (!response.ok) throw new Error(`Failed to fetch image: ${response.statusText}`);
  
  //     const blob = await response.blob();
  
  //     // Convert Blob to Base64
  //     return new Promise((resolve, reject) => {
  //       const reader = new FileReader();
  //       reader.onloadend = () => resolve(reader.result.split(",")[1]); // Extract Base64 part
  //       reader.onerror = reject;
  //       reader.readAsDataURL(blob);
  //     });
  //   } catch (error) {
  //     console.error("Error fetching image:", error);
  //     return null;
  //   }
  // };
  
  // // ✅ Example usage
  // (async () => {
  //   const base64 = await fetchImageAsBase64("profile_images/1739603180_profile_satheesh.png");
  //   if (base64) {
  //     console.log("Base64 String:", base64);
  //     // Use it in an <img> tag or anywhere you need
  //     document.getElementById("profileImage").src = `data:image/png;base64,${base64}`;
  //   }
  // })();
  // Function to generate and download vCard
  const downloadVCard = () => {
    if (!userData) {
      alert("User data is still loading. Please wait.");
      return;
    }

    const { 
      name, designation, roll, mobile, telephone, email, 
      address, website, facebook, instagram, skype 
    } = userData;

    const vCardData =
      `BEGIN:VCARD\r\n` +
      `VERSION:3.0\r\n` +
      `N:${name}\r\n` +
      `FN:${name}\r\n` +
      `TITLE:${roll}\r\n` +
      `ROLE:${designation}\r\n` +
      `TEL;TYPE=CELL:${mobile}\r\n` +
      (telephone ? `TEL;TYPE=WORK:${telephone}\r\n` : "") +
      `EMAIL:${email}\r\n` +
      `ADR;TYPE=WORK:${address}\r\n` +
      `URL:${website}\r\n` +
      `URL:${facebook}\r\n` +
      `URL:${instagram}\r\n` +
      `URL:${skype}\r\n`  +
      `PHOTO;ENCODING=BASE64;TYPE=JPEG:\r\n ` + // Space before Base64 data is required
      `${base64Image}\r\n` + // Base64 data properly formatted
      `END:VCARD\r\n`;

    const blob = new Blob([vCardData], { type: "text/vcard" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "contact.vcf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      {loading ? (
        <button disabled>Loading...</button>
      ) : (
        <StyledIcon as={HiUserAdd} onClick={downloadVCard} />
      )}
    </div>
  );
};

export default VCardGenerator;
